import axios from "axios";
import { APIURL } from "../config";

const SendForgotPasswordMailApi = async (user) => {
  const url = APIURL + "/account/forgotpassword";
  return await axios.post(url, user);
};

export default SendForgotPasswordMailApi;
